<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // temp: ""
    };
  },
  mounted() {},

  computed: {
    // temp() {
    //   return this.$route.path;
    // }
  },

  methods: {}
};
</script>
<style>
html,
body {
  height: 100%;
  width: 100%;
  background-color: #122346;
}
</style>



// WEBPACK FOOTER //
// src/App.vue